import { GetStaticProps } from 'next'
import React from 'react'

import { Container } from '@/components/Container'
import { Head } from '@/components/Head'
import { Header } from '@/components/Header'
import { Layout } from '@/components/Layout'
import { ListedAttributes } from '@/components/ListedAttributes'
// eslint-disable-next-line sort-imports
import { getMasterData, MasterData } from '@/lib/UkiyoeData'

export const getStaticProps: GetStaticProps = async () => {
  const master = getMasterData()

  return {
    props: {
      data: master,
    },
  }
}

type Props = {
  data: MasterData
}

const Attributes = ({ data }: Props) => {
  return (
    <Layout>
      <Head path="/" />
      <Container>
        <Header />
        <ListedAttributes data={data} />
      </Container>
    </Layout>
  )
}

export default Attributes
